export default "__VITE_ASSET__Bbv82xNa__"